import { POST_BUYOUT_FAILURE, UPDATE_BUYOUT_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';

export const useBuyoutHandler = ({ updateBuyout, postBuyout, showToast, fileId }) => {
  
  const handleUpdateHomesaleBuyout = async (values) => {
    try {
      const resp = await updateBuyout(fileId, values);
      if (resp.type === UPDATE_BUYOUT_FAILURE) {
        showToast('Failed to update homesale buyout info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return false;
      }
      return true;
    } catch (error) {
      showToast('An unexpected error occurred while updating homesale buyout info.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    }
  };

  const handleCreateHomesaleBuyout = async (values) => {
    try {     
      const resp = await postBuyout(fileId, values);
      if (resp.type === POST_BUYOUT_FAILURE) {
        showToast('Failed to create homesale buyout info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return false;
      }
      return true;
    } catch (error) {
      showToast('An unexpected error occurred while creating homesale buyout info.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    }
  };

  return {
    handleUpdateHomesaleBuyout,
    handleCreateHomesaleBuyout,
  };
};
